import { GeoLocationPayload, GeoLocationReturn } from "@/api/types";
import { baseApi } from "./base";

const geoLocationApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getGeoLocation: builder.mutation<GeoLocationReturn, GeoLocationPayload>({
      query: (payload) => {
        return {
          url: "/location/geolocate",
          method: "POST",
          body: payload,
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetGeoLocationMutation } = geoLocationApi;
